import React, { useState } from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import { withStyles } from '@material-ui/core/styles';

const AvailabilitySlots = ({
  provider,
  dateRange,
  availabilities,
  appointmentSelected,
  classes,
}) => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <Collapse in={showMore} collapsedHeight="256px">
        <Grid container justifyContent="space-between" spacing={8}>
          {dateRange.map(date => {
            let slots = availabilities[date.format('YYYY-MM-DD')] || [];
            let formattedSlots = slots.map(slot => ({
              ...slot,
              startEpicTime: new Date(slot.start).getTime(),
            }));
            formattedSlots = formattedSlots.sort(
              (slot1, slot2) => slot1.startEpicTime - slot2.startEpicTime
            );
            const key = `provider-${provider.id}-${date.format('YYYY-MM-DD')}`;

            return (
              <Grid
                item
                xs={4}
                lg="auto"
                key={key}
                className={classes.availabilityRow}
              >
                <div className={classes.availabilityRow}>
                  <span className={classes.availabilityDay}>
                    {date.format('ddd MMM Do')}
                  </span>

                  {formattedSlots.map(availability => {
                    const {
                      id: tenancyId,
                      color: tenancyColor,
                    } = availability.tenancy;
                    const availabilitySlotStyle = {
                      backgroundColor: tenancyColor,
                    };
                    const key = `${availability.start} ${tenancyId}`;

                    return (
                      <Button
                        key={key}
                        onClick={() =>
                          appointmentSelected(availability, provider)
                        }
                        style={availabilitySlotStyle}
                        className={classes.availabilityButton}
                      >
                        {moment(availability.start).format('h:mma')}
                      </Button>
                    );
                  })}
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Collapse>

      <Grid item xs={12}>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={() => setShowMore(!showMore)}
          className={classes.scheduleButton}
        >
          {showMore ? 'Collapse Schedule' : 'Show Full Schedule'}
        </Button>
      </Grid>
    </>
  );
};

const styles = () => ({
  availabilityRow: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    minHeight: '225px',
  },
  availabilityDay: {
    color: '#8C8C8C',
    fontSize: '14px',
    lineHeight: '21px',
    marginBottom: '12px',
  },
  availabilityButton: {
    marginBottom: '8px',
    padding: '8px 16px',
    color: 'white',
    borderRadius: '2px',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight:'Bold'
  },
  scheduleButton: {
    display: 'block',
    margin: 'auto',
  },
});

export default withStyles(styles)(AvailabilitySlots);
